import { Component } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { MainMenuComponent, Menu, MenuComponent, MenuIcon, NavigationComponent } from '@camelot/menu';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [MainMenuComponent, MenuComponent, NavigationComponent, TestIdDirective],
    template: `
    <cam-menu camTestId="nm-menu" [menu]="this.menu" container="main" />
    <cam-main-menu camTestId="nm-main-menu" [menuMain]="this.menu" [menuUser]="this.menu" />
    <button camTestId="nm-toggle-item" (click)="this.toggleItem()">toggle item</button>
    <cam-menu-navigation camTestId="nm-tabs" [menu]="this.tabsMenu" container="tab" />
  `
})
export class NavMenuCase {
  public itemVisible$ = new BehaviorSubject<boolean>(true);
  public menu = new Menu({
    elements: [
      new MenuIcon({ icon: 'edit', key: 'go-smoke', label: 'go-smoke-label', link: '/e2e-harness/smoke' }),
      new MenuIcon({ icon: 'add', key: 'other', label: 'other-label', visible$: this.itemVisible$ }),
    ],
  });
  public tabsMenu = new Menu({
    elements: [
      new MenuIcon({ icon: 'edit', key: 'tab-one', label: 'tab-one-label', link: '/e2e-harness/nav-menu' }),
      new MenuIcon({ icon: 'add', key: 'tab-two', label: 'tab-two-label', link: '/e2e-harness/smoke' }),
    ],
  });

  public toggleItem(): void {
    this.itemVisible$.next(!this.itemVisible$.value);
  }
}
